import { render, staticRenderFns } from "./TabItinerary.vue?vue&type=template&id=1ede887c&scoped=true&"
import script from "./TabItinerary.vue?vue&type=script&lang=js&"
export * from "./TabItinerary.vue?vue&type=script&lang=js&"
import style0 from "./TabItinerary.vue?vue&type=style&index=0&id=1ede887c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ede887c",
  null
  
)

export default component.exports